export const PHONE_NUMBER_ROLES = ['ivr', 'pool', 'source', 'messaging', 'ai-agent'] as const
export type PhoneNumberRole = (typeof PHONE_NUMBER_ROLES)[number]
